import '../studyCreationGuide.scss';

interface BubbleProps {
  style?: React.CSSProperties;
  type: 'active' | 'inactive';
}

export const Bubble: React.FC<BubbleProps> = ({ children, style, type }) => {
  return (
    <div className={`bubble ${type}`} style={style}>
      {children}
    </div>
  );
};
